export { authPanelReducer, type AuthPanelRootState } from './model/auth-panel-slice';
